// i18n.js
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './locales/en.json';
import sv from './locales/sv.json';
import fi from './locales/fi.json';

Vue.use(VueI18n);

const messages = { en, sv, fi };

const i18n = new VueI18n({
  locale: 'sv', 
  fallbackLocale: 'sv',
  messages,
});

export default i18n;